import React from 'react';

import { withLayout } from '../PuckLayout';
import formatIntl from '../Common/formatIntl';
import PuckButtonRender from './PuckButtonRender';
import {
  ButtonRadioField,
  ConnectedTargetCollectionField,
  ConnectedTargetFileField,
  TargetUrlField,
  TargetPageField,
} from './ButtonFields';

const PuckButton = {
  get label() { return formatIntl('Button'); },

  fields: {
    text: {
      type: 'text',
      get label() { return formatIntl('Text'); },
    },
    size: {
      type: 'custom',
      get label() { return formatIntl('Size'); },
      options: [
        { get label() { return formatIntl('Small'); }, value: 'sm' },
        { get label() { return formatIntl('Medium'); }, value: 'md' },
        { get label() { return formatIntl('Large'); }, value: 'lg' },
      ],
      render: (props) => <ButtonRadioField {...props} />,
    },
    color: {
      type: 'custom',
      get label() { return formatIntl('Color'); },
      options: [
        { get label() { return formatIntl('Primary'); }, value: 'primary' },
        { get label() { return formatIntl('Secondary'); }, value: 'secondary' },
        { get label() { return formatIntl('Link'); }, value: 'link' },
      ],
      render: (props) => <ButtonRadioField {...props} />,
    },
    align: {
      type: 'custom',
      get label() { return formatIntl('Align'); },
      options: [
        { get label() { return formatIntl('Left'); }, value: 'left' },
        { get label() { return formatIntl('Center'); }, value: 'center' },
        { get label() { return formatIntl('Right'); }, value: 'right' },
      ],
      render: (props) => <ButtonRadioField {...props} />,
    },
    targetType: {
      type: 'custom',
      get label() { return formatIntl('Point to'); },
      options: [
        { get label() { return formatIntl('Collection'); }, value: 'collection' },
        { get label() { return formatIntl('File'); }, value: 'file' },
        { get label() { return formatIntl('URL'); }, value: 'url' },
        { get label() { return formatIntl('Page'); }, value: 'page' },
      ],
      render: (props) => <ButtonRadioField {...props} />,
    },
    targetCollection: {
      type: 'custom',
      get label() { return formatIntl('Collection'); },
      render: (props) => <ConnectedTargetCollectionField {...props} />,
    },
    targetFile: {
      type: 'custom',
      get label() { return formatIntl('File'); },
      render: (props) => <ConnectedTargetFileField {...props} />,
    },
    url: {
      type: 'custom',
      get label() { return formatIntl('URL'); },
      render: (props) => <TargetUrlField {...props} />,
    },
    targetPage: {
      type: 'custom',
      get label() { return formatIntl('Page'); },
      render: (props) => <TargetPageField {...props} />,
    },
  },

  get defaultProps() {
    return {
      text: formatIntl('Button'),
      size: 'lg',
      color: 'primary',
      align: 'left',
      targetType: 'url',
      targetCollection: null,
      targetFile: null,
      targetPage: null,
      url: '',
      layout: {
        padding: '0px',
      },
    };
  },

  render: (props) => <PuckButtonRender {...props} />,
};

export default withLayout(PuckButton);
